import React, { useState, useEffect } from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import Modal from 'components/Modal/Modal';
import keys from 'config/keys';
import styles from 'config/styles';
import urls from "config/urls";
// import todoIcon from "./markers/marker-todo.svg";
// import todoIconSelected from "./markers/marker-todo-selected.svg";
// import doingIcon from "./markers/marker-doing.svg";
// import doingIconSelected from "./markers/marker-doing-selected.svg";
// import doneIcon from "./markers/marker-done.svg";
// import doneIconSelected from "./markers/marker-done-selected.svg";
import AxiosInterceptor from "../../../../AxiosInterceptor";
import './TasksMapModal.scss'
import TaskDetailDrawer from './components/TaskDetailDrawer/TaskDetailDrawer';
import configurationService from 'services/configurationService';


const DEFAULT_LOCATION = { lat: -34.603722, lng: -58.381592 };
interface TasksMapModalProps {
  mode?: 'all' | 'user';
  isOpen: boolean;
  onClose: (refreshOnClose?: boolean) => void;
}

const TasksMapModal: React.FC<TasksMapModalProps> = ({ isOpen, onClose, mode }) => {
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [mapCenter, setMapCenter] = useState(DEFAULT_LOCATION);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [records, setRecords] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [selectedMarkerId, setSelectedMarkerId] = useState(null);
  const [taskDetailDrawerIsVisible, setTaskDetailDrawerIsVisible] = useState(false);
  const [fields, setFields] = React.useState([] as any);
  const [leftCells, setLeftCells] = React.useState([] as any);
  const [rightCells, setRightCells] = React.useState([] as any);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: keys.googleMaps || "",
  });
  const mapStyles = styles.googleMap;
  const filters: any = [
    //["status", "!=", "done"],
  ]
  const loadRecords = async () => {
    try {

      setLoading(true);

      let url = "";
      if (mode == "all") {
        url = `${urls.server
          }/api/tasks-with-address?filters=${encodeURIComponent(
            JSON.stringify(filters)
          )}`;
      } else {
        url = `${urls.server
          }/api/my/tasks-with-address?filters=${encodeURIComponent(
            JSON.stringify(filters)
          )}`;
      }
      const res = await AxiosInterceptor.get(url);
      const data = await res?.data;

      if (data) {
        setRecords(data);
      }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);

    }
  };
  useEffect(() => {
    if (isOpen && !mapLoaded) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setMapCenter({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          () => {
            // Si el usuario no da permiso o hay un error, usa la ubicación por defecto (CABA)
            setMapCenter(DEFAULT_LOCATION);
          }
        );
      } else {
        // El navegador no soporta Geolocation
        setMapCenter(DEFAULT_LOCATION);
      }
      setMapLoaded(true);
    }
    if (isOpen) {
      loadRecords();
    }
  }, [isOpen, mapLoaded]);
  useEffect(() => {
    if (selectedMarkerId) {
      setTaskDetailDrawerIsVisible(true)
    } else {
      setTaskDetailDrawerIsVisible(false);
    };
  }, [selectedMarkerId]);
  const paths: any = {
    "to-do": "m 26.074507,2.9164 -0.960936,0.9668 1.878899,1.8496 a 1.7635866,1.7635867 89.643107 0 0 -0.136711,0.668 1.7635866,1.7635867 89.643107 0 0 1.763685,1.7637 1.7635866,1.7635867 89.643107 0 0 1.439453,-0.752 l 3.615234,0.7578 0.2832,-1.3535 -3.607422,-0.7559 A 1.7635866,1.7635867 89.643107 0 0 28.619447,4.6371 1.7635866,1.7635867 89.643107 0 0 27.955384,4.7699 Z", // Aquí iría el contenido de d="" para to-do
    "doing": "M 32.305492,6.3134388 A 3.3468127,3.3468127 0 0 1 28.95868,9.6602515 3.3468127,3.3468127 0 0 1 25.611867,6.3134388 3.3468127,3.3468127 0 0 1 28.95868,2.966626 3.3468127,3.3468127 0 0 1 32.305492,6.3134388 Z", // Contenido de d="" para doing
    "done": "m 26.074507,2.9164 -0.960936,0.9668 1.878899,1.8496 a 1.7635866,1.7635867 89.643107 0 0 -0.136711,0.668 1.7635866,1.7635867 89.643107 0 0 1.763685,1.7637 1.7635866,1.7635867 89.643107 0 0 1.439453,-0.752 l 3.615234,0.7578 0.2832,-1.3535 -3.607422,-0.7559 A 1.7635866,1.7635867 89.643107 0 0 28.619447,4.6371 1.7635866,1.7635867 89.643107 0 0 27.955384,4.7699 Z"   // Contenido de d="" para done
  };
  const generateSVG = (fillColor: string, invertedFillColor: string, taskStatus: string) => {
    return `
      <svg
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
      <path
      style="fill:#cccccc;"
      d="M 28.847656 1.5820312 A 6.1660714 6.1660714 0 0 0 23.949219 4.03125 L 18.361328 4.0097656 C 17.959492 4.0097656 17.574634 4.0747595 17.212891 4.1933594 L 17.085938 4.2324219 C 16.49639 4.4050217 15.94085 4.6623754 15.361328 5.046875 L 15.107422 5.2304688 C 14.70103 5.5184685 14.291671 5.8572723 13.851562 6.2636719 C 12.837404 7.2649709 11.882519 8.2369104 10.857422 9.2246094 L 10.113281 10.017578 C 9.9064457 10.220878 9.6921214 10.469435 9.4707031 10.740234 L 8.890625 11.507812 L 8.4726562 12.236328 C 8.3295928 12.519728 8.1889068 12.839088 8.0996094 13.117188 C 7.9684131 13.519787 7.9045522 13.765191 7.8671875 14.400391 C 7.7888356 18.085187 7.848546 21.776841 7.859375 25.460938 C 7.862885 26.848636 7.8829173 27.082238 7.9101562 27.273438 L 8.0097656 27.738281 C 8.2193509 28.69508 8.6008053 29.573904 9.1347656 30.345703 C 9.3580082 30.680003 9.6085428 30.983225 9.8828125 31.265625 C 10.198999 32.320624 11.266665 33.090813 13.064453 33.320312 L 19.640625 39.894531 L 26.236328 33.298828 L 26.236328 33.296875 C 26.451372 33.250875 26.66764 33.194859 26.880859 33.130859 L 26.90625 33.130859 C 27.329957 33.008159 27.786456 32.810559 28.226562 32.568359 C 29.233434 32.02886 30.066588 31.266987 30.695312 30.367188 L 30.878906 30.076172 C 31.395555 29.250773 31.743927 28.311021 31.904297 27.294922 L 31.919922 27.271484 C 31.948172 27.081185 31.967063 26.846783 31.970703 25.458984 L 31.970703 13.050781 A 6.1660714 6.1660714 0 0 0 35.013672 7.7480469 A 6.1660714 6.1660714 0 0 0 28.847656 1.5820312 z " />
   <path
   style="fill:${invertedFillColor};"
      d="M 28.847656 0.4921875 A 6.1660714 6.1660714 0 0 0 25.103516 1.78125 C 25.063903 1.7799682 25.052477 1.7764975 25.009766 1.7753906 L 18.361328 1.75 C 17.959491 1.75 17.574635 1.8155407 17.212891 1.9316406 L 17.085938 1.96875 C 16.496393 2.1413498 15.94085 2.4004566 15.361328 2.7851562 L 15.107422 2.96875 C 14.701031 3.2565497 14.291669 3.5956535 13.851562 4.0019531 C 12.837402 5.0034521 11.882516 5.9752916 10.857422 6.9628906 L 10.113281 7.7558594 C 9.9064467 7.9589592 9.6921245 8.2080159 9.4707031 8.4785156 L 8.890625 9.2460938 L 8.4726562 9.9746094 C 8.3295928 10.257809 8.1889068 10.577569 8.0996094 10.855469 C 7.9684122 11.258268 7.9045272 11.503573 7.8671875 12.138672 C 7.7888356 15.823568 7.848546 19.515322 7.859375 23.199219 C 7.862885 24.587017 7.8829173 24.820319 7.9101562 25.011719 L 8.0097656 25.474609 C 8.2193508 26.431308 8.6008053 27.312085 9.1347656 28.083984 C 9.3580062 28.418184 9.6085439 28.719453 9.8828125 29.001953 C 10.198996 30.057152 11.266663 30.828894 13.064453 31.058594 L 19.640625 37.632812 L 26.236328 31.037109 C 26.451372 30.991109 26.66764 30.935094 26.880859 30.871094 L 26.90625 30.871094 C 27.329957 30.748294 27.786456 30.551194 28.226562 30.308594 C 29.233434 29.769394 30.066588 29.007921 30.695312 28.107422 L 30.878906 27.816406 C 31.395554 26.991007 31.743925 26.051355 31.904297 25.035156 L 31.919922 25.009766 C 31.948172 24.819466 31.967063 24.587117 31.970703 23.199219 L 31.970703 11.974609 A 6.1660714 6.1660714 0 0 0 35.013672 6.6582031 A 6.1660714 6.1660714 0 0 0 28.847656 0.4921875 z " />
   <path
      style="fill:${fillColor};"
      d="m 18.361328,5.4453 -0.140625,0.035 c -0.536692,0.137 -1.042813,0.4667 -1.857422,1.2187 -0.316183,0.2917 -1.092476,1.064 -1.183593,1.1778 -0.04556,0.057 -0.166435,0.194 -0.267579,0.3046 -0.102961,0.1104 -0.213152,0.2361 -0.24414,0.2774 -0.03189,0.041 -0.08853,0.097 -0.125,0.123 -0.03644,0.025 -0.160457,0.1326 -0.273438,0.2383 -0.113904,0.1085 -0.245719,0.2225 -0.294922,0.2617 -0.09568,0.075 -0.864802,0.8471 -1.171875,1.1778 -0.379968,0.4081 -0.644715,0.732 -0.83789,1.0215 -0.127585,0.1901 -0.295846,0.52 -0.34961,0.6894 -0.07928,0.2443 -0.08008,0.2775 -0.08008,1.4082 v 0.1895 0.025 0.025 0.024 0.025 0.025 0.025 0.025 0.024 0.025 2.6875 c 0,7.4455 8.43e-4,7.8301 0.02539,7.9902 0.176779,1.1293 0.830363,2.0712 1.814453,2.6133 0.26607,0.146 0.573916,0.2613 0.882812,0.3359 l -0.03906,0.025 h 0.0625 0.103516 0.0098 0.01172 0.0059 c 0.09748,0.025 0.195337,0.035 0.291016,0.043 h 0.04687 0.01172 0.0625 0.0293 0.0293 0.03516 0.03516 0.03906 0.04101 0.04492 0.04687 0.04883 0.05273 0.05274 0.05859 0.05859 0.06055 0.06445 0.06641 0.06836 0.142578 0.07422 0.07617 0.08008 0.08008 0.08203 0.628906 0.09766 0.09766 0.839844 0.113281 0.113281 0.81836 0.121093 0.121094 0.123047 0.123047 0.123047 0.126953 0.24414 5.244141 0.002 c 0.44284,-0.046 0.933449,-0.1985 1.326172,-0.416 0.985002,-0.5422 1.638591,-1.4825 1.814453,-2.6114 0.02461,-0.1602 0.02539,-0.5451 0.02539,-7.9902 0,-2.2178 -0.0011,-2.8339 -0.002,-3.9785 a 6.1660714,6.1660714 0 0 1 -0.515625,-0.045 6.1660714,6.1660714 0 0 1 -1.03711,-0.2774 6.1660714,6.1660714 0 0 1 -0.974609,-0.455 6.1660714,6.1660714 0 0 1 -0.880859,-0.6153 6.1660714,6.1660714 0 0 1 -0.121094,-0.1211 c 0.0069,0.4466 0.0098,1.7872 0.0098,5.5235 v 5.666 l -0.02344,0.098 c -0.0656,0.2781 -0.191593,0.4995 -0.384766,0.6797 -0.174947,0.162 -0.375202,0.268 -0.623046,0.3281 -0.07654,0.025 -0.233176,0.024 -2.898438,0.024 h -1.130859 -0.72461 c -2.666159,0 -2.821894,-4e-4 -2.898437,-0.025 -0.24875,-0.059 -0.448097,-0.1636 -0.623047,-0.3281 -0.193179,-0.18 -0.318249,-0.3997 -0.384766,-0.6778 l -0.02344,-0.098 v -5.666 -1.6329 -0.02 -0.3769 -0.039 -0.033 -0.035 -0.025 c 0.0028,-0.2944 0.01166,-0.3412 0.06445,-0.4415 0.0656,-0.1228 0.212553,-0.2301 0.384765,-0.2773 0.209585,-0.057 0.207439,-0.058 1.615235,-0.062 h 1.306641 l 0.08789,-0.027 c 0.213214,-0.073 0.345851,-0.2121 0.402344,-0.4297 0.01904,-0.08 0.01953,-0.1297 0.01953,-1.2344 0,-1.1574 0.0061,-1.4282 0.03906,-1.6152 0.0474,-0.2805 0.153693,-0.4609 0.322265,-0.543 l 0.06055,-0.029 h 2.134766 c 1.673629,0 2.088873,2e-4 2.18164,0.022 A 6.1660714,6.1660714 0 0 1 23.507916,9.4595 6.1660714,6.1660714 0 0 1 23.054792,8.4849 6.1660714,6.1660714 0 0 1 22.775495,7.4478 6.1660714,6.1660714 0 0 1 22.681745,6.3755 6.1660714,6.1660714 0 0 1 22.763775,5.4419 h -1.03711 z" />
        <path
          style="fill:${fillColor};"
          d="${paths[taskStatus]}"
        />
      </svg>
    `;
  };
  const getMarkerSVG = (taskStatus: string, isSelected: boolean) => {
    const fillColor = isSelected ? "#ffffff" : "#e16945";
    const invertedFillColor = isSelected ? "#e16945" : "#ffffff";
    return generateSVG(fillColor, invertedFillColor, taskStatus);
  };
  const getConfigurationNames = (mode: any) => {
    const prefix = mode === 'user' ? 'my' : '';
    return [
      `${prefix}TaskMapLeftCells`,
      `${prefix}TaskMapRightCells`,
      `${prefix}TaskMapFields`,
    ];
  };

  // useEffect(() => {
  //   if (isOpen) {
  //     setLoadingConfig(true);
  //     const configurationNames = [
  //       "myTaskMapLeftCells",
  //       "myTaskMapRightCells",
  //       "myTaskMapFields",
  //     ];
  //     configurationService
  //       .findByNames(configurationNames)
  //       .then((configurations) => {
  //         setLoadingConfig(false);
  //         configurations.forEach((configuration: any) => {
  //           switch (configuration.name) {
  //             case "myTaskMapLeftCells":
  //               setLeftCells(configuration.json_schema);
  //               break;
  //             case "myTaskMapRightCells":

  //               setRightCells(configuration.json_schema);
  //               break;
  //             case "myTaskMapFields":
  //               setFields(configuration.json_schema);
  //               break;

  //             default:
  //             // Manejar cualquier otro caso
  //           }
  //         });
  //       })
  //       .catch((error) => {
  //         setLoadingConfig(false);
  //         console.log(error);
  //       });
  //   } else {
  //     setLoadingConfig(false);
  //   }
  // }, [isOpen]);
  useEffect(() => {
    if (isOpen) {
      setLoadingConfig(true);

      const configurationNames = getConfigurationNames(mode);

      configurationService
        .findByNames(configurationNames)
        .then((configurations) => {
          setLoadingConfig(false);
          configurations.forEach((configuration: any) => {
            switch (configuration.name) {
              case configurationNames[0]:
                setLeftCells(configuration.json_schema);
                break;
              case configurationNames[1]:
                setRightCells(configuration.json_schema);
                break;
              case configurationNames[2]:
                setFields(configuration.json_schema);
                break;
              default:
              // Manejar cualquier otro caso
            }
          });
        })
        .catch((error) => {
          setLoadingConfig(false);
          console.log(error);
        });
    } else {
      setLoadingConfig(false);
    }
  }, [isOpen, mode]); // Asegúrate de incluir 'mode' como dependencia

  if (!isOpen || !isLoaded) {
    return null; // No renderiza nada si no está abierto o si las APIs no están cargadas
  }

  return (
    <Modal
      title={"Mapa de Tareas"}
      className={'tasks-map-modal-container'}
      isOpen={isOpen}
      onClose={onClose}

    >
      {isLoaded && !loadingConfig &&
        !loading ? (
        <GoogleMap
          mapContainerStyle={{
            position: "absolute",

            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          options={{
            styles: mapStyles,
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: false
          }}
          center={mapCenter}
          zoom={10}
        >
          {
            records.map((item: any, index: number) => {
              const isSelected = item.id === selectedMarkerId;

              return (

                <Marker
                  key={index}
                  icon={{
                    // Pasas el SVG como una URL en una cadena de texto
                    url: `data:image/svg+xml;utf-8, ${encodeURIComponent(getMarkerSVG(item.status, isSelected))}`,
                    scaledSize: new window.google.maps.Size(50, 50),
                  }}
                  position={{ lat: Number(item.address?.lat), lng: Number(item.address?.lng) }}
                  onClick={() => {
                    setSelectedMarkerId(isSelected ? null : item.id)


                  }}
                />
              );
            })
          }
        </GoogleMap>
      ) : <></>}
      <TaskDetailDrawer
        taskId={selectedMarkerId}
        fields={fields}
        onHide={(res: any) => {
          setTaskDetailDrawerIsVisible(false);
          setSelectedMarkerId(null)
        }}
        isVisible={taskDetailDrawerIsVisible} />
    </Modal>
  );
};

export { TasksMapModal };
